import {PartnerPositionVehicleCacheEntry} from './partner-position-vehicle-cache.entry';

export class PartnerPositionTrackEntry {
  public id: number;
  public blob: Blob;
  public vehicles: PartnerPositionVehicleCacheEntry[];

  constructor(item: any) {
    this.id = item.id;
    this.blob = item.blob;
    this.vehicles = item.vehicles != null
      ? item.vehicles.map((entry) => new PartnerPositionVehicleCacheEntry(entry))
      : [];
  }
}
